import store from "../../store";

export function checkPermissions(permission: string) {
  const userPermissions: string[] =
    store.getState()?.main?.user?.permissions || [];

  if (!permission || !userPermissions) {
    return false;
  }

  if (Array.isArray(permission)) {
    return !!userPermissions.find((obj) => permission.includes(obj));
  } else {
    return userPermissions.includes(permission);
  }
}
